import React, { useEffect, useState } from "react";
import projectTitle from "../../assets/icons/projectTitle.svg";
import style from "./Header.module.css";
import SelectDropdown from "../SelectDropDown/SelectDropdown.js";
import { getAllClients, createClient, createProject, getProjectByClientId } from "../../services/homeService";
import FormDialog from "../Popup/FormDialog.js";
import AddProjectModal from '../Popup/AddProjectModal.jsx'
import { useDispatch, useSelector } from "react-redux";
import { setSelectedClient, setIsClientModal, setisProjectModal, setSelectedClientProjects,setLoading } from "../../store/slice/clientSlice.js";
import {setIsBugPage } from "../../store/slice/bugSlice.js";
import {setIsBugDashboard } from "../../store/slice/bugSlice";
import {setIsProjectSetup} from "../../store/slice/setupSlice.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { deleteCookie, getCookie } from "../../services/utils.js";
import userIcon from '../../assets/icons/user_icon.svg'
import axios from "axios";

const Header = () => {
  const [clientList, setClientList] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [projectData, setProjectData] = useState({
    name:'',
    username: '',
    url: '',
    password: ''
  })
  const dispatch = useDispatch();
  const location = useLocation()
  const navigate = useNavigate()
  const { selectedClient, isClientModal, isProjectModal, loading, selectedClientProjects } = useSelector((state)=>{ return state.clientDetails })
  const { isBugPage, isBugSummaryModal, isBugDashboard } = useSelector((state) => { return state.bugDetails });
  const { isProjectSetup } = useSelector((state) => { return state.setupDetails });
  const [clientData, setClientData] = useState({})
  const {guid} = useParams();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const firstName = getCookie("firstName")
  const email = getCookie('email');
  useEffect(() => {
    getAllClientsApi();
  }, []);

  const handleSelectClient = (selectClient) => {
    // Don't clear projects here, check if we need to fetch them first
    getProjectByClientIdApi(selectClient)
    dispatch(setSelectedClient({value:selectClient.value, label:selectClient.label}))
    dispatch(setIsBugPage(false))
    dispatch(setIsBugDashboard(false))
    dispatch(setIsProjectSetup(false))
    const state = { clientName: selectClient.label};
    navigate(`/client/${selectClient.value}`, { state });
  };

  const getProjectByClientIdApi = async (client) => {
    let clientId = client?.value;
    if(clientId){
      try{
        // Check if we already have projects for this client
        const hasProjectsForClient = selectedClientProjects && 
                                     selectedClientProjects.length > 0 && 
                                     selectedClientProjects[0]?.clientId === parseInt(clientId);
        
        if (hasProjectsForClient) {
          console.log("Using cached projects from Redux store");
          // We already have the projects in Redux, no need to fetch
          return;
        }
        
        // If not in Redux, fetch from API
        dispatch(setLoading(true));
        const resp = await getProjectByClientId(clientId);
        dispatch(setSelectedClientProjects(resp));
        dispatch(setLoading(false));
        
      }catch(error){
        console.error("Error fetching projects:", error.message);
        dispatch(setLoading(false));
      }
    }
  }

  const disableProjects = !selectedClient?.label

  const getAllClientsApi = async () => {
    try {
      const resp = await getAllClients();
      let optionsClientList = resp?.map((client) => ({
        value: client?.id,
        label: client?.name,
      }));
      setClientList(optionsClientList);
    } catch (error) {
      console.error("Error fetching clients:", error.message);
    }
  };

  const disableClient = clientList.length === 0;

  const handleAddClient = () => {
    dispatch(setIsClientModal(true))
  };

  const handleAddProject = () => {
    dispatch(setisProjectModal(true));
  };

  const handleCloseModal = () => {
    dispatch(setIsClientModal(false))
    dispatch(setisProjectModal(false));
    setInputValue("");
    setProjectData({
      name:'',
      username: '',
      url: '',
      password: ''
    })
  };
  const handleNavigateToHome = () => {
    !guid && navigate("/")
  }
  useEffect(() => {
    setClientData(selectedClient)
  }, [selectedClient])

  const handleCreateClient = async () => {
    try {
      await createClient(inputValue);
      dispatch(setIsClientModal(false));
      setInputValue("");
      await getAllClientsApi();
    } catch (error) {
      console.error("Error creating client:", error.message);
    }
  };

  const handleCreateProject = async() => {
    try {
      await createProject(projectData, selectedClient.value);
      dispatch(setisProjectModal(false));
      setProjectData({
        name:'',
        username: '',
        url: '',
        password: ''
      })
      await getProjectByClientIdApi(selectedClient)
    } catch (error) {
      console.error("Error creating client:", error.message);
    }
  };
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handlelogout = async (e) => {
    const token = getCookie('token');

    await axios.post(`${process.env.REACT_APP_IDENTITY_BASE_URL}api/v1/logout`, null, {
        headers: {
            Authorization: token,
        },
    }).then(() => {
        deleteCookie('User');
        deleteCookie('token');
        deleteCookie('userGuid');
        deleteCookie('firstName');
        window.location.href = process.env.REACT_APP_LOGIN_URL + '/login'
    }).catch((e) => {
        console.log('e', e);
    });
};

 const userRole = getCookie('role')

  return (
    <>
      <nav className={style.header}>
        <div className={style.logoContainer}>
          <img src={projectTitle} alt="projectTile" onClick={()=> {handleNavigateToHome()}} style={{cursor: guid ? 'default' : "pointer"}}/>
        </div>
        {
          !guid && <>
        
          <div className={style.clientViewer}>
            <span className={style["text"]}>Client</span>
            <div className={style["dropdown"]}>
              <SelectDropdown
                options={clientList}
                onChange={handleSelectClient}
                value={selectedClient}
                isSearchable={false}
                isDisabled={disableClient || isBugDashboard || isBugSummaryModal || isBugPage || isProjectSetup || loading}
                isMulti={false}
                width="180px"
              />
            </div>
          </div>
  
          <div className={style.buttonContainer}>
            <button disabled={userRole === 'CONTRACTOR'} className={`${style["btn-box"]} ${(isBugPage || isBugDashboard || (selectedClient?.label) || isProjectSetup) ? style["disabled"] : style["client"]}`}>
              <span onClick={handleAddClient}>+ Add Client</span>
            </button>
            <button className={`${style["btn-box"]} ${(loading ||disableProjects || isBugDashboard || isBugPage || isProjectSetup ) ? style["disabled"] : style["project"]}`} style={{marginLeft: "20px", marginRight: "50px"}}>
              <span onClick={handleAddProject}>+ Add Project</span>
            </button>
            
            <div className={style['user-dropdown']}>
            <img src={userIcon} onClick={toggleDropdown} alt="User Profile" />
            {dropdownOpen && (
              <div className={style["dropdown-menu"]}>
                <div>{firstName}
                  <span>{email}</span></div>
                <button className={style['logout-button']} onClick={handlelogout}>Logout</button>
              </div>
            )}

          </div>

          </div>
          </>
        }
        
      </nav>
      
      <FormDialog
        open={isClientModal}
        handleClose={handleCloseModal}
        handleCreate={() => handleCreateClient()}
        title="Add Client"
        placeHolder="Enter Client Name"
        inputValue={inputValue}
        setInputValue={(value) => {
          // Validate input with alphanumeric and special characters
          // const validatedValue = value.slice(0, 100).replace(/[^a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/g, '');
          // setInputValue(validatedValue);
          setInputValue(value);
        }}
      />
      <AddProjectModal
        open={isProjectModal}
        handleClose={handleCloseModal}
        handleCreate={() => handleCreateProject()}
        projectData={projectData}
        setProjectData={setProjectData}
      />
    </>
  );
};

export default Header;
